export default __webpack_public_path__ + "static/media/nissannavara.b07f3e1b.webp";